import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { catchError, from, of, switchMap, take } from 'rxjs';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false,
})
export class RegisterComponent {
    form: FormGroup;

    registerInProgress = false;
    constructor(
        private readonly fb: FormBuilder,
        private readonly authService: AuthService,
        private readonly router: Router,
        private messageService: MessageService,
    ) {
        this.form = this.fb.group({
            email: ['', [Validators.email, Validators.required]],
            password: ['', [Validators.minLength(6), Validators.required]],
            phoneNumber: [
                '',
                [
                    Validators.minLength(9),
                    Validators.maxLength(9),
                    Validators.pattern('^5[0-9]{8}$'),
                    Validators.required,
                ],
            ],
            name: ['', [Validators.minLength(5), Validators.required]],
        });
    }

    register() {
        if (this.form.valid) {
            this.registerInProgress = true;
            this.authService
                .register(this.form.value)
                .pipe(
                    take(1),
                    switchMap(() => {
                        this.registerInProgress = false;
                        return from(this.router.navigate(['auth/login']));
                    }),
                    catchError((e) => {
                        this.messageService.add({ severity: 'error', detail: e?.error?.message });
                        this.registerInProgress = false;
                        return of(true);
                    }),
                )
                .subscribe();
        }
    }
}
